import * as PrivateAxios from "axios"
import moment from "moment-timezone"
import axios from "@/config/axios"

let allOrdersRequestSeq = 0

const initialState = () => {
  return {
    allOrders: [],
    caseInformation: {},
    caseInformationValidationErrors: {},
    caseInformationValidationErrorsCode: {},
    caseUpdateInformationValidationErrorsCode: {},
    accessionCreationValidationErrors: {},
    caseInformationSaveStatus: false,
    caseInformationErr: null,
    caseDeleteStatus: false,
    caseDeleteError: null,
    attachmentUploadURL: null,
    attachmentFileId: null,
    attachmentUploadStatusUpdated: false,
    attachmentUploadStatus: false,

    attachmentDeleteStatus: false,

    accessionCreateStatus: false,
    allOrderErrors: null,
    restoreOrderStatus: false,
    restoreOrderError: false,
    // Global search
    globalSearchOrders: [],

    showMedication: false,

    deleteOrderBillingInfoStatus: false,
    downloadOrderDataStatus: false,
    accessionCreationValidationErrorCode: {},
    report: null,
    requisitionDownloadStatus: false,
    toxutiRequisition: null,
    multipleBarcodeSources: [],
    multipleBarcodeStatus: false,
    testgoOrderBarcodeSources: [],
    testgoOrderBarcodeStatus: false,
    validationOrders: [],
    updateValidationStatus: false,
    bulkValidations: false,
    scanOrderLogs: [],
    getOrderDetails: null,
    scanOrderMeta: null,
    createAccessionDetails: null,
    updateOrderStatus: null,
    orderCounts: {},
    singleOrderTestsInfo: [],
    sendLabOrdersToPhlebio: false,
    caseConversionErrorsStatus: false,
    testTubeInfoById: [],
  }
}

const state = initialState()

const getters = {
  getCaseInformationValidationErrors: (state) =>
    state.caseInformationValidationErrors,
  getCaseInformationSaveStatus: (state) => state.caseInformationSaveStatus,
  getAllOrders: (state) => state.allOrders,
  getAllOrderErrors: (state) => state.allOrderErrors,

  getCaseInformation: (state) => state.caseInformation,

  getCaseDeleteStatus: (state) => state.caseDeleteStatus,
  getCaseDeleteError: (state) => state.caseDeleteError,

  getFileUploadURLForAttachments: (state) => state.attachmentUploadURL,
  getFileUploadRefIdForAttachment: (state) => state.attachmentFileId,
  getAttachmentUploadStatusUpdated: (state) =>
    state.attachmentUploadStatusUpdated,
  getAttachmentUploadStatus: (state) => state.attachmentUploadStatus,
  getAttachmentDeleteStatus: (state) => state.attachmentDeleteStatus,
  getAccessionCreateStatus: (state) => state.accessionCreateStatus,
  getAccessionCreationValidationErrors: (state) =>
    state.accessionCreationValidationErrors,
  getAccessionCreationValidationErrorCode: (state) =>
    state.accessionCreationValidationErrorCode,
  getRestoreOrderStatus: (state) => state.restoreOrderStatus,
  getRestoreOrderError: (state) => state.restoreOrderError,

  getGlobalSearchOrders: (state) => state.globalSearchOrders,

  getShowMedication: (state) => state.showMedication,

  getDeleteOrderBillingInfoStatus: (state) =>
    state.deleteOrderBillingInfoStatus,
  getDownloadOrderDataStatus: (state) => state.downloadOrderDataStatus,

  getCaseInformationValidationErrorsCode: (state) =>
    state.caseInformationValidationErrorsCode,
  getCaseUpdateInformationValidationErrorsCode: (state) =>
    state.caseUpdateInformationValidationErrorsCode,
  getReport: (state) => state.report,
  getDownloadReportStatus: (state) => state.requisitionDownloadStatus,

  getToxUtiRequisitionForm: (state) => state.toxutiRequisition,
  getMultipleBarcodeSources: (state) => state.multipleBarcodeSources,
  getMultipleBarcodeStatus: (state) => state.multipleBarcodeStatus,
  getTestgoOrderBarcodeSources: (state) => state.testgoOrderBarcodeSources,
  getTestgoOrderBarcodeStatus: (state) => state.testgoOrderBarcodeStatus,
  getValidationOrders: (state) => state.validationOrders,
  getUpdateValidationStatus: (state) => state.updateValidationStatus,
  getBulkValidations: (state) => state.bulkValidations,
  getScanOrderLogs: (state) => state.scanOrderLogs,
  getScanOrderDetails: (state) => state.getOrderDetails,
  getScanOrderMeta: (state) => state.scanOrderMeta,
  getCreateAccessionDetails: (state) => state.createAccessionDetails,
  getUpdateOrderStatus: (state) => state.updateOrderStatus,
  getOrderCounts: (state) => state.orderCounts,
  getSingleOrderTestsInfo: (state) => state.singleOrderTestsInfo,
  getRequiresAttentionCount: (state) => {
    return state.allOrders.filter((order) =>
      ["ACTIVE", "PARTIAL"].includes(order.status),
    ).length
  },
  getLabsquireToPhlebioStatus: (state) => state.sendLabOrdersToPhlebio,
  getCaseConversionErrorsStatus: (state) => state.caseConversionErrorsStatus,
  getTestTubeInfoById: (state) => state.testTubeInfoById,
}

const mutations = {
  setCaseInformationValidationErrors(state, data) {
    state.caseInformationValidationErrors = data
  },

  setCaseInformationSaveStatus(state, data) {
    state.caseInformationSaveStatus = data
  },

  setAllOrders(state, data) {
    state.allOrders = data
  },
  setAllOrderErrors(state, data) {
    state.allOrderErrors = data
  },

  setCaseInformationError(state, data) {
    state.caseInformationErr = data
  },
  setCaseInformation(state, data) {
    state.caseInformation = data
  },

  setCaseDeleteError(state, data) {
    state.caseDeleteError = data
  },
  setCaseDeleteStatus(state, data) {
    state.caseDeleteStatus = data
  },

  setFileUploadURLForAttachments(state, data) {
    state.attachmentUploadURL = data
  },
  setFileUploadRefIdForAttachment(state, data) {
    state.attachmentFileId = data
  },
  setAttachmentUploadStatusUpdated(state, data) {
    state.attachmentUploadStatusUpdated = data
  },
  setAttachmentUploadStatus(state, data) {
    state.attachmentUploadStatus = data
  },
  setAttachmentDeleteStatus(state, data) {
    state.attachmentDeleteStatus = data
  },
  setAccessionCreateStatus(state, data) {
    state.accessionCreateStatus = data
  },
  setAccessionCreationValidationErrors(state, data) {
    state.accessionCreationValidationErrors = data
  },
  setAccessionCreationValidationErrorCode(state, data) {
    state.accessionCreationValidationErrorCode = data
  },

  setRestoreOrderStatus(state, data) {
    state.restoreOrderStatus = data
  },
  setRestoreOrderError(state, data) {
    state.restoreOrderError = data
  },
  setGlobalSearchOrders(state, data) {
    state.globalSearchOrders = data
  },

  setShowMedication(state, status) {
    state.showMedication = status
  },
  setDeleteOrderBillingInfoStatus(state, status) {
    state.deleteOrderBillingInfoStatus = status
  },
  setDownloadOrderDataStatus(state, status) {
    state.downloadOrderDataStatus = status
  },
  setCaseInformationValidationErrorsCode(state, data) {
    state.caseInformationValidationErrorsCode = data
  },
  setCaseUpdateInformationValidationErrorsCode(state, data) {
    state.caseUpdateInformationValidationErrorsCode = data
  },
  setRequisition(state, report) {
    state.report = report
  },
  setRequisitionDownloadStatus(state, report) {
    state.requisitionDownloadStatus = report
  },
  setToxUtiRequisitionForm(state, data) {
    state.toxutiRequisition = data
  },
  setMultipleBarcodeSources(state, data) {
    state.multipleBarcodeSources = data
  },
  setMultipleBarcodeStatus(state, data) {
    state.multipleBarcodeStatus = data
  },
  setTestgoOrderBarcodeSources(state, data) {
    state.testgoOrderBarcodeSources = data
  },
  setTestgoOrderBarcodeStatus(state, data) {
    state.testgoOrderBarcodeStatus = data
  },
  setUpdateOrderStatus(state, status) {
    state.updateOrderStatus = status
  },
  setValidationOrders(state, data) {
    state.validationOrders = data
  },
  setUpdateValidationStatus(state, data) {
    state.updateValidationStatus = data
  },
  setBulkValidations(state, data) {
    state.bulkValidations = data
  },
  setScanOrderLogs(state, data) {
    state.scanOrderLogs = data
  },
  setGetOrderDetails(state, data) {
    state.getOrderDetails = data
  },
  setScanOrderMeta(state, data) {
    state.scanOrderMeta = data
  },
  setCreateAccessionDetails(state, data) {
    state.createAccessionDetails = data
  },
  setOrderCounts(state, data) {
    state.orderCounts = data
  },
  setSingleOrderTestsInfo(state, data) {
    state.singleOrderTestsInfo = data
  },
  setSendLabOrderToPhlebio(state, data) {
    state.sendLabOrdersToPhlebio = data
  },
  setCaseConversionErrorsStatus(state, data) {
    state.caseConversionErrorsStatus = data
  },
  setTestTubeInfoById(state, data) {
    state.testTubeInfoById = data
  },
  reset(state) {
    const initial = initialState()
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key]
    })
  },
}
const actions = {
  getOrders: async ({ commit, dispatch }, params) => {
    // Sequence guard: only the most recently issued request is allowed to
    // commit its result, so a slow older request can't clobber a newer one.
    const { __requestSeq, ...requestParams } = params || {}
    if (typeof __requestSeq === "number") {
      allOrdersRequestSeq = __requestSeq
    }
    try {
      await dispatch("errors/clear", null, {
        root: true,
      })
      let response = []
      if (params) {
        response = await axios.get("/testgo-orders", {
          params: requestParams,
        })
      } else {
        response = await axios.get("/testgo-orders")
      }
      if (typeof __requestSeq === "number" && __requestSeq !== allOrdersRequestSeq) {
        return
      }
      commit("setAllOrders", response.data)
    } catch (err) {
      commit("setAllOrderErrors", true)
      await dispatch("errors/errorResponse", err.response, {
        root: true,
      })
    }
  },

  fetchTechnicianNames: async (_, params) => {
    try {
      const response = await axios.get("/testgo-orders/technician-names", { params })
      return response.data
    } catch (err) {
      return []
    }
  },

  fetchRequisitionById: async ({ commit, dispatch }, params) => {
    try {
      let orderId = params.orderId
      delete params.orderId
      commit("setRequisition", null)
      commit("errors/clear", null, { root: true })
      const response = await axios.get(`orders/${orderId}/e-requisition`, {
        params,
      })

      commit("setRequisition", response.data)
    } catch (err) {
      commit("setRequisition", null)
      if (err.response) {
        await dispatch("errors/errorResponse", err.response, { root: true })
      }
    }
  },
  fetchErequisitionReport: async ({ commit, dispatch }) => {
    try {
      const response = await axios.fetch(
        "https://dev-api.labsquire.com/e-req-forms/microgen_tox_uti_v1.pdf",
      )
      console.log(response)
    } catch (err) {
      console.log(err)
    }
  },
  downloadRequisitionForm: async ({ commit, dispatch }, params) => {
    try {
      let order_id = params.orderId
      delete params.orderId
      commit("setRequisitionDownloadStatus", false)
      commit("errors/clear", null, { root: true })
      const response = await axios.get(
        "orders/" + order_id + "/e-requisition",
        {
          params,
        },
      )
      let data = response.data
      const linkSource = `data:application/pdf;base64,${data}`
      const donwloadLink = document.createElement("a")

      const fileName = "requisition.pdf"
      donwloadLink.href = linkSource
      donwloadLink.download = fileName
      donwloadLink.click()

      commit("setRequisitionDownloadStatus", true)
    } catch (err) {
      commit("setRequisitionDownloadStatus", null)
      if (err.response) {
        await dispatch("errors/errorResponse", err.response, { root: true })
      }
    }
  },
  createNewCase: async (context, params) => {
    try {
      context.commit(
        "orders/setCaseInformationValidationErrors",
        {},
        {
          root: true,
        },
      )
      context.commit(
        "orders/setCaseInformationValidationErrorsCode",
        {},
        {
          root: true,
        },
      )
      context.commit("orders/setCaseInformationSaveStatus", false, {
        root: true,
      })
      const response = await axios.post("/orders", params)
      context.commit("orders/setCaseInformation", response.data.data, {
        root: true,
      })
      context.commit("orders/setCaseInformationSaveStatus", true, {
        root: true,
      })
      if (
        params.case_types.indexOf("TOXICOLOGY") > -1 ||
        params.case_types.indexOf("PGX_TEST") > -1
      ) {
        context.commit("orders/setShowMedication", true, {
          root: true,
        })
      } else {
        context.commit("orders/setShowMedication", false, {
          root: true,
        })
      }
    } catch (error) {
      context.commit("orders/setCaseInformationSaveStatus", false, {
        root: true,
      })
      if (error.response) {
        context.commit(
          "orders/setCaseInformationValidationErrorsCode",
          error.response.data,
          { root: true },
        )
        let errorData = await context.dispatch(
          "errors/errorResponse",
          error.response,
          {
            root: true,
          },
        )
        context.commit("orders/setCaseInformationValidationErrors", errorData, {
          root: true,
        })
      }
    }
  },

  updateOrderDetails: async ({ commit, dispatch }, params) => {
    try {
      commit("setCaseInformationValidationErrors", {})
      commit("setCaseInformationSaveStatus", false)
      commit("setCaseUpdateInformationValidationErrorsCode", {})
      const id = params.order_id
      delete params.order_id
      const response = await axios.put(`/testgo-order/${id}`, params)
      commit("setCaseInformation", response.data.data)
      commit("setCaseInformationSaveStatus", true)
      if (
        params.case_types.indexOf("TOXICOLOGY") > -1 ||
        params.case_types.indexOf("PGX_TEST") > -1
      ) {
        commit("setShowMedication", true)
      } else {
        commit("setShowMedication", false)
      }
    } catch (error) {
      commit("setCaseInformationSaveStatus", false)
      if (error.response) {
        let errorData = await dispatch("errors/errorResponse", error.response, {
          root: true,
        })
        commit("setCaseInformationValidationErrors", errorData)
        commit(
          "setCaseUpdateInformationValidationErrorsCode",
          error.response.data,
        )
      }
    }
  },
  downloadOrdersData: async ({ commit }, params) => {
    try {
      commit("setDownloadOrderDataStatus", false)
      const response = await axios.get("/testgo-orders/download-as-csv", {
        params,
      })
      commit("setDownloadOrderDataStatus", true)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement("a")
      link.href = url
      const currentDate = moment().tz("America/New_York")
      const fileName = currentDate.format("MM-DD-YYYY_hh-mm_A")
      link.setAttribute("download", `orders_${fileName}.csv`) //or any other extension
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      commit("setDownloadOrderDataStatus", false)
      console.log(error)
    }
  },


  fetchCaseInformation: async ({ commit }, params) => {
    try {
      let response = null
      if (params.isOldOrder) {
        response = await axios.get("/orders/" + params.order_id)
        commit("setCaseInformation", response.data.data)
      } else {
        response = await axios.get("/testgo-order/" + params.order_id)
      }
      commit("setCaseInformation", response.data.data)
      if (
        response.data.data.case_types.indexOf("TOXICOLOGY") > -1 ||
        response.data.data.case_types.indexOf("PGX_TEST") > -1
      ) {
        commit("setShowMedication", true)
      } else {
        commit("setShowMedication", false)
      }
    } catch (error) {
      if (error && error.data && error.data.message) {
        commit("setCaseInformationError", error.data.message)
      } else {
        commit("setCaseInformationError", "Error while getting the data")
      }
    }
  },

  fetchOrderDetails: async (_, orderId) => {
    const response = await axios.get("/testgo-order/" + orderId);
    return response.data.data;
  },

  deleteCase: async ({ commit, dispatch }, params) => {
    try {
      let order_id = params.order_id
      delete params.order_id
      commit("setCaseDeleteStatus", false)
      await axios.delete("/orders/" + order_id, {
        data: params,
      })
      commit("setCaseDeleteStatus", true)
    } catch (error) {
      if (error && error.data && error.data.message) {
        commit("setCaseDeleteError", error.data.message)
      } else {
        commit("setCaseDeleteError", "Error while deleting case")
      }
    }
  },

  fetchDocumentUploadUrl: async ({ commit }, params) => {
    try {
      commit("setFileUploadURLForAttachments", null)
      commit("setFileUploadRefIdForAttachment", null)
      const response = await axios.post(
        "/orders/" + params.order_id + "/" + params.type,
        params,
      )
      const data = response.data.data
      commit("setFileUploadURLForAttachments", data.target_url)
      commit("setFileUploadRefIdForAttachment", data.hash)
    } catch (error) {
      console.log(error)
    }
  },

  uploadDocumentToGeneratedUrl: async ({ commit }, params) => {
    try {
      commit("setAttachmentUploadStatus", false)
      let pAxios = PrivateAxios.create({})
      await pAxios.put(params.upload_url, params.file, {
        headers: {
          "Content-Type": params.file.type,
        },
      })
      commit("setAttachmentUploadStatus", true)
    } catch (error) {
      commit("setAttachmentUploadStatus", false)
    }
  },
  updateDocumentUploadStatus: async ({ commit }, params) => {
    try {
      commit("setAttachmentUploadStatusUpdated", false)
      await axios.patch(
        "/orders/" +
          params.order_id +
          "/" +
          params.type +
          "/" +
          params.hash +
          "/status",
      )
      commit("setAttachmentUploadStatusUpdated", true)
    } catch (error) {
      commit("setAttachmentUploadStatusUpdated", false)
    }
  },

  deleteAttachment: async ({ commit }, params) => {
    try {
      commit("setAttachmentDeleteStatus", false)
      await axios.delete(
        "/orders/" + params.order_id + "/attachments/" + params.id,
        {
          data: params,
        },
      )
      commit("setAttachmentDeleteStatus", true)
    } catch (error) {
      commit("setAttachmentDeleteStatus", false)
    }
  },

  createAccessionForOrder: async ({ commit, dispatch }, params) => {
    try {
      commit(
        "orders/setAccessionCreationValidationErrors",
        {},
        {
          root: true,
        },
      )
      commit("setCaseConversionErrorsStatus", false)
      commit(
        "orders/setAccessionCreationValidationErrorCode",
        {},
        {
          root: true,
        },
      )
      commit("orders/setAccessionCreateStatus", false, {
        root: true,
      })
      commit("orders/setCreateAccessionDetails", null, {
        root: true,
      })
      let response = await axios.post(
        "testgo-orders/" + params.order + "/create-accession-number",
        params,
      )
      commit("orders/setAccessionCreateStatus", true, {
        root: true,
      })
      commit("orders/setCreateAccessionDetails", response.data.data, {
        root: true,
      })
    } catch (error) {
      commit("setCaseConversionErrorsStatus", true)
      commit("orders/setAccessionCreateStatus", false, {
        root: true,
      })
      commit("orders/setCreateAccessionDetails", null, {
        root: true,
      })
      if (error.response) {
        const errorData = await dispatch(
          "errors/errorResponse",
          error.response,
          {
            root: true,
          },
        )
        commit("setAccessionCreationValidationErrorCode", error.response.data)
        commit("setAccessionCreationValidationErrors", errorData)
      }
    }
  },

  restoreArchivedOrder: async ({ commit, dispatch }, params) => {
    try {
      commit("setRestoreOrderError", null)
      commit("setRestoreOrderStatus", false)
      let status = {
        status: params.status,
      }
      await axios.patch("/orders/" + params.order_id + "/restoreOrder", status)
      commit("setRestoreOrderStatus", true)
    } catch (err) {
      commit("setRestoreOrderStatus", false)
      if (err.response) {
        commit(
          "setRestoreOrderError",
          err.response.message || "Error at restore order",
        )
      } else {
        commit("setRestoreOrderError", "Error at restore order")
      }
    }
  },
  fetchGlobalSearchOrdersData: async ({ commit, dispatch }, params) => {
    try {
      await dispatch("errors/clear", [], {
        root: true,
      })
      let response = []
      if (params) {
        response = await axios.get("/testgo-orders-search", {
          params,
        })
      } else {
        response = await axios.get("/testgo-orders-search")
      }
      commit("setGlobalSearchOrders", response.data)
    } catch (err) {
      commit("setAllOrderErrors", true)
      await dispatch("errors/errorResponse", err.response, {
        root: true,
      })
    }
  },

  deleteBillingInfo: async ({ commit }, order_id) => {
    try {
      commit("setDeleteOrderBillingInfoStatus", false)
      await axios.delete(`orders/${order_id}/billing-information`)
      commit("setDeleteOrderBillingInfoStatus", true)
    } catch (err) {
      commit("setDeleteOrderBillingInfoStatus", false)
    }
  },
  generateMultipleBarcodes: async ({ commit }, params) => {
    try {
      commit("setMultipleBarcodeStatus", false)
      commit("setMultipleBarcodeSources", [])
      const response = await axios.post("/orders/generate-bar-codes", params)
      commit("setMultipleBarcodeStatus", true)
      commit("setMultipleBarcodeSources", response.data.data)
    } catch (error) {
      commit("setMultipleBarcodeStatus", false)
    }
  },
  generateTestgoOrderBarcodes: async ({ commit }, params) => {
    try {
      commit("setTestgoOrderBarcodeStatus", false)
      commit("setTestgoOrderBarcodeSources", [])
      const response = await axios.post("/testgo-orders/generate-bar-codes", params)
      commit("setTestgoOrderBarcodeStatus", true)
      commit("setTestgoOrderBarcodeSources", response.data.data)
    } catch (error) {
      commit("setTestgoOrderBarcodeStatus", false)
    }
  },
  fetchValidationOrders: async ({ commit, dispatch }, params) => {
    try {
      await dispatch("errors/clear", [], { root: true })

      const response = await axios.get("/validation-orders", { params })

      commit("setValidationOrders", response.data)
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true })
      }
    }
  },
  changeCaseValidationStatus: async ({ commit }, params) => {
    try {
      commit("setUpdateValidationStatus", false)
      await axios.patch(
        "/orders/" + params.id + "/validation-status/" + params.status,
        { validation_reason: params.validation_reason },
      )
      commit("setUpdateValidationStatus", true)
    } catch (error) {
      if (error.response) {
        console.log(error.response)
      }
    }
  },
  swapOrderInsurance: async (_ctx, params) => {
    try {
      const response = await axios.post("/testgo-orders/" + params.order_id + "/swap-insurance")
      return response.data
    } catch (error) {
      if (error.response) {
        return error.response.data
      }
      throw error
    }
  },
  markOrderPriority: async (_ctx, params) => {
    try {
      const response = await axios.patch(
        "/testgo-orders/" + params.order_id + "/mark-priority",
        {
          is_priority: params.is_priority,
          priority_reason: params.priority_reason,
        },
      )
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response)
        return error.response.data
      }
      throw error
    }
  },
  updateBulkValidations: async ({ commit, dispatch }, params) => {
    try {
      let status = params.status
      delete params.status
      commit("setBulkValidations", false)

      await axios.patch(`/orders/validation-status/${status}/bulk`, params)

      commit("setBulkValidations", true)
    } catch (error) {
      commit("setBulkValidations", false)
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true })
      }
    }
  },
  resetGenerateMultipleBarcodes: async ({ commit }) => {
    commit("setMultipleBarcodeStatus", false)
    commit("setMultipleBarcodeSources", [])
  },
  resetGenerateTestgoOrderBarcodes: async ({ commit }) => {
    commit("setTestgoOrderBarcodeStatus", false)
    commit("setTestgoOrderBarcodeSources", [])
  },
  fetchScanOrderLogs: async ({ commit, dispatch }, params) => {
    try {
      commit("setScanOrderLogs", [])
      commit("errors/clear", null, { root: true })
      const response = await axios.get("/audit-logs/scan-order", { params })

      commit("setScanOrderLogs", response.data)
    } catch (err) {
      commit("setScanOrderLogs", [])
      if (err.response) {
        await dispatch("errors/errorResponse", err.response, { root: true })
      }
    }
  },
  fetchScanOrderById: async ({ commit, dispatch }, params) => {
    try {
      let orderId = params.orderId
      delete params.orderId
      commit("setGetOrderDetails", null)
      commit("setScanOrderMeta", null)
      commit("errors/clear", null, { root: true })
      const response = await axios.get(`testgo-orders/by-order-id/${orderId}`, {
        params,
      })

      commit("setGetOrderDetails", response.data.data)
      commit("setScanOrderMeta", {
        count: response.data.count,
        link_id: response.data.link_id,
      })
    } catch (err) {
      commit("setGetOrderDetails", null)
      commit("setScanOrderMeta", null)
      if (err.response) {
        await dispatch("errors/errorResponse", err.response, { root: true })
      }
    }
  },
  changeOrderStatus: async ({ commit }, params) => {
    try {
      commit("setUpdateOrderStatus", null);
      let requestData, config = {};
      if (params.formData) {
        requestData = params.formData;
        config.headers = { "Content-Type": "multipart/form-data" };
      } else {
        requestData = params;
      }
      let response = await axios.patch(
        "/orders/" + params.id + "/status",
        requestData,
        config
      );
      commit("setUpdateOrderStatus", response.data);
    } catch (error) {
      if (error.response) {
        console.log(error.response)
      }
    }
  },
  rejectOrder: async ({ commit }, params) => {
    try {
      commit("setUpdateOrderStatus", null);

      let requestData = params;
      const config = {};

      const hasImages =
        Array.isArray(params.images) &&
        params.images.length > 0;

      if (hasImages) {
        const formData = new FormData();

        Object.keys(params).forEach((key) => {
          if (key === "images") {
            params.images.forEach((image) => {
              if (image) {
                formData.append(
                  "images",
                  image
                );
              }
            });

            return;
          }

          if (key === "case_types") {
            formData.append(
              "case_types",
              JSON.stringify(
                params.case_types || []
              )
            );

            return;
          }

          if (
            params[key] !== undefined &&
            params[key] !== null
          ) {
            formData.append(
              key,
              params[key]
            );
          }
        });

        requestData = formData;
      }

      const response =
        await axios.patch(
          `/orders/${params.order_id}/order-rejection`,
          requestData,
          config
        );

      commit(
        "setUpdateOrderStatus",
        response.data
      );

      return response.data;

    } catch (error) {
      const errorData =
        error.response?.data || {};

      const updateStatus = {
        ...errorData,

        success: false,

        message:
          errorData.message ||
          "Error while rejecting order",
      };

      commit(
        "setUpdateOrderStatus",
        updateStatus
      );

      console.error(
        "Order rejection error:",
        error.response?.data || error
      );

      return updateStatus;
    }
  },
  partialActivateOrder: async ({ commit }, params) => {
    try {
      commit("setUpdateOrderStatus", null);

      const orderId = params.order_id;

      const { order_id, ...body } = params;

      let requestData = body;
      const config = {};

      const hasImages =
        Array.isArray(body.images) &&
        body.images.length > 0;

      if (hasImages) {
        const formData = new FormData();

        Object.keys(body).forEach((key) => {
          if (key === "images") {
            body.images.forEach((image) => {
              if (image) {
                formData.append(
                  "images",
                  image
                );
              }
            });

            return;
          }

          if (key === "activation_data") {
            formData.append(
              "activation_data",
              JSON.stringify(
                body.activation_data || []
              )
            );

            return;
          }

          if (
            body[key] !== undefined &&
            body[key] !== null
          ) {
            formData.append(
              key,
              body[key]
            );
          }
        });

        requestData = formData;
      }

      const response = await axios.patch(
        `/orders/${orderId}/partial-active`,
        requestData,
        config
      );

      commit(
        "setUpdateOrderStatus",
        response.data
      );

      return response.data;

    } catch (error) {
      const errorData = error.response?.data || {};

      const updateStatus = {
        ...errorData,

        success: false,

        message:
          errorData.message ||
          "Error while activating order",
      };

      commit(
        "setUpdateOrderStatus",
        updateStatus
      );

      console.error(
        "Order partial activation error:",
        error.response?.data || error
      );

      return updateStatus;
    }
  },
  fetchOrderStats: async ({ commit }) => {
    try {
      commit("setOrderCounts", {})

      let response = await axios.get("/pending-rejection-testgoorder/stats")
      commit("setOrderCounts", response.data.data)
    } catch (err) {
      console.log(err)
      commit("setOrderCounts", {})
    }
  },
  fetchOrderTestsInfo: async ({ commit }, params) => {
    let case_types = params.case_types[0] || []
    try {
      let response = await axios.get(
        `/testgo-orders/${params.order}/tests-info?case_types=${case_types}`,
      )
      commit("setSingleOrderTestsInfo", response.data.data)
    } catch (err) {
      console.log(err)
      commit("setOrderCounts", {})
    }
  },
  sendLabOrdersToPhlebio: async ({ commit, dispatch }, params) => {
    try {
      let order_id = params.order_id
      delete params.order_id
      commit("setSendLabOrderToPhlebio", false)
      await axios.post(
        `${process.env.VUE_APP_PHLEBIO_URL}/phlebio-orders/orders/${order_id}/send`,
        {
          to_address_type: params.to_address,
          address_value: params.address_value,
        },
      )
      commit("setSendLabOrderToPhlebio", true)
    } catch (error) {
      commit("setSendLabOrderToPhlebio", false)
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, {
          root: true,
        })
      }
    }
  },
  updateMlxOrderSample: async ({ dispatch }, params) => {
    try {
      const orderId = params.order_id
      const payload = params.payload
      const response = await axios.post(
        `/mlx-orders/update-sample/${orderId}`,
        payload,
      )
      return response.data
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, {
          root: true,
        })
      }
      throw error
    }
  },
  updateSampleRecollection: async ({ dispatch }, params) => {
    try {
      const orderId = params.order_id
      const payload = params.payload
      const response = await axios.post(
        `/mlx-orders/update-sample/${orderId}`,
        payload,
      )
      return response.data
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, {
          root: true,
        })
      }
      throw error
    }
  },
  updateSampleAcknowledgement: async ({ dispatch }, params) => {
    try {
      const payload = params.payload
      let response

      try {
        response = await axios.post(
          `/testgo-orders/sample-acknowledgement`,
          payload,
        )
      } catch (error) {
        throw error
      }

      return response.data
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, {
          root: true,
        })
      }
      throw error
    }
  },
  reviewSampleApproval: async ({ dispatch }, params) => {
    try {
      const orderId = params.order_id
      const payload = params.payload
      const response = await axios.post(
        `/testgo-orders/${orderId}/sample-pending-review`,
        payload,
      )
      return response.data
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, {
          root: true,
        })
      }
      throw error
    }
  },
  editMlxOrderSample: async ({ dispatch }, params) => {
    try {
      const orderId = params.order_id
      const payload = params.payload
      const response = await axios.patch(`/mlx/edit-sample/${orderId}`, payload)
      return response.data
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, {
          root: true,
        })
      }
      throw error
    }
  },
  fetchOrderTestsTubeInfo: async ({ commit }, orderId) => {
    try {
      commit("setTestTubeInfoById", [])
      let response = await axios.get(`/testgo-tube-info/${orderId}`)
      commit("setTestTubeInfoById", response.data.data)
    } catch (err) {
      console.log(err)
      commit("setOrderCounts", {})
    }
  },
  logTestTubeSelection: async (_, params) => {
    try {
      await axios.post("/testgo-orders/log", params)
    } catch (err) {
      console.log(err)
    }
  },
  logOrderDateChange: async (_, params) => {
    try {
      await axios.post(
        `/testgo-orders/${params.order_id}/date-change-log`,
        { changes: params.changes },
      )
    } catch (err) {
      console.log(err)
    }
  },
  fetchOrderTestsTubeInfoBulk: async (_, payload) => {
    try {
      const ids = Array.isArray(payload) ? payload : payload.ids;
      const includeRejected = !Array.isArray(payload) && payload.includeRejected === true;
      const response = await axios.post(`/testgo-tube-info/bulk`, {
        ids,
        includeRejected,
      })
      return response.data.data || {}
    } catch (err) {
      console.log(err)
      return {}
    }
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
